import { render, staticRenderFns } from "./RoomsList.vue?vue&type=template&id=1a3c7a5b&lang=pug&"
import script from "./RoomsList.vue?vue&type=script&lang=ts&"
export * from "./RoomsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports